import React, { useState, useEffect } from "react";
import "./style.scss";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { Link } from "react-router-dom";
import { ReactComponent as Wave } from "../../assets/images/wave.svg";
import { httpService } from "../../base/services/httpService.service";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useDispatch, useSelector } from "react-redux";
import { createUser } from "./authSlice";
import { LocalStorageService } from "../../base/services/local-storage.service";
import { Formik, Form, Field } from "formik";
import { useLocation, useNavigate } from "react-router-dom";
import Toast from "../../base/components/Toast";
import { registerUser } from "./authSlice";
import * as Yup from "yup";
import { Icon } from "react-icons-kit";
import { eye } from "react-icons-kit/feather/eye";
import { eyeOff } from "react-icons-kit/feather/eyeOff";

const initialValues = {
   email: "",
   password: "",
   confirmPassword: "",
   internationalName: "",
   dateOfEstablishment: null,
   description: "",
   sectors: [],
   baseCountryId: null,
   orgTypeId: 1, //we need to set this for the moment as 1 statically
   orgSizeId: null,
   address: "",
   organizationEmail: ""
};

function RegistrationOfNationalOrganization() {
   const [sectorList, setSectorList] = useState([]);
   const [orgSizeList, setOrgSizeList] = useState([]);
   const [countryList, setCountryList] = useState([]);

   const [type, setType] = useState("password");
   const [icon, setIcon] = useState(eyeOff);

   const [confirmType, setConfirmType] = useState("password");
   const [confirmIcon, setConfirmIcon] = useState(eyeOff);

   const dispatch = useDispatch();
   const navigate = useNavigate();

   const validationSchema = Yup.object().shape({
      email: Yup.string()
         .email("Invalid email address")
         .required("Email is required"),
      password: Yup.string()
         .min(8, "Password must be at least 8 characters")
         .required("Password is required"),
      confirmPassword: Yup.string()
         .oneOf([Yup.ref("password"), null], "Passwords must match")
         .required("Confirm Password is required"),
      internationalName: Yup.string().required("International Organization's name is required"),
      dateOfEstablishment: Yup.date()
         .nullable()
         .required("Foundation year is required"),
      description: Yup.string().required("Organization description is required"),
      sectors: Yup.array()
         .min(1, "At least one sector must be selected")
         .required("Sectors are required"),
      baseCountryId: Yup.object().shape({
         value: Yup.string().required("Base country is required"),
         label: Yup.string().required("Base country is required")
      }),
      orgSizeId: Yup.object().shape({
         value: Yup.number().required("Organization size is required"),
         label: Yup.string().required("Organization size is required")
      }),
      address: Yup.string().required("Organization address is required"),
      organizationEmail: Yup.string()
         .email("Invalid organization email")
         .required("Organization's email is required"),
      acceptTerms: Yup.boolean().oneOf([true], "You must accept the terms and conditions")
   });
   useEffect(() => {
      httpService.get(`/organization/sectors/null`, (data) => {
         const sectorData = data.dataResult.map((sector) => {
            return {
               value: sector.id,
               label: sector.name
            };
         });
         setSectorList(sectorData);
      });
      httpService.get(`/organization/sizes`, (data) => {
         const orgSizeData = data.dataResult.map((size) => {
            return {
               value: size.id,
               label: size.range
            };
         });
         setOrgSizeList(orgSizeData);
      });
      httpService.get(`/country/fordropdownlist/null`, (data) => {
         const countryData = data.dataResult.map((country) => {
            return {
               value: country.id,
               label: country.name
            };
         });
         setCountryList(countryData);
      });
   }, []);

   const onSubmit = async (values) => {
      try {
         console.log("values", values);
         const orgSizeIdValue = values.orgSizeId.value;
         const baseCountryIdValue = values.baseCountryId.value;
         const sectorValues = values.sectors.map((sector) => sector.value);

         const updatedValues = {
            ...values,
            baseCountryId: baseCountryIdValue,
            orgSizeId: orgSizeIdValue,
            sectors: sectorValues
         };
         console.log("valuies", values);
         dispatch(
            registerUser(updatedValues, (user) => {
               console.log("userId", user);
               LocalStorageService.setItem("userId", user.userId);
               navigate(`/auth/confirm-code`);
            })
         );
      } catch (error) {
         console.error("Error during form submission:", error);
      }
   };

   const handleTogglePassword = () => {
      if (type === "password") {
         setIcon(eye);
         setType("text");
      } else {
         setIcon(eyeOff);
         setType("password");
      }
   };

   const handleToggleConfirmPassword = () => {
      if (confirmType === "password") {
         setConfirmIcon(eye);
         setConfirmType("text");
      } else {
         setConfirmIcon(eyeOff);
         setConfirmType("password");
      }
   };

   // const onSubmit = (values) => {};

   return (
      <div>
         <nav className="navbar navbar-ngo">
            <div className="container">
               <div className="logo-ingo">
                  <img
                     src={toAbsoluteUrl("/media/logos/kapOrg-logo.svg")}
                     width="100"
                     height="36"
                     className="d-inline-block d-sm-flex justify-content-sm-center align-items-sm-center"
                     alt="NGO Logo"
                  />
               </div>
               <div className="col-12 col-md-9">
                  <h2 className="ingo-navbartext">
                     NGO /&nbsp;<span className="text-white"> National Organization</span>
                  </h2>
               </div>
            </div>
         </nav>
         <div className="bg-white py-5">
            <div className="container d-flex justify-content-around ">
               <div className="mt-5 col-12 col-md-6">
                  <h4 className="sign-up-info">Sign Up Information</h4>

                  <p className="signup-p">
                     To create your account, please fill in the following information.
                  </p>
               </div>
            </div>
         </div>
         <div className="bg-form">
            <div className="container">
               <div className="row justify-content-center">
                  <div className="col-12 col-md-6">
                     <div>
                        <h5 className="login__credtext">Login Credentials</h5>
                     </div>
                     <Formik
                        initialValues={initialValues}
                        onSubmit={onSubmit}
                        validationSchema={validationSchema}
                     >
                        {({ values, handleChange, setFieldValue, errors, touched }) => (
                           <Form>
                              {/* Login Credentials */}
                              <div className="p-8 bg-white mt-28 form-styleNGO">
                                 <div>
                                    <div className="form-group">
                                       <label htmlFor="email">Email*</label>
                                       <Field type="email" name="email" className="form-control" />
                                       {errors.email && touched.email && (
                                          <div className="text-danger">{errors.email}</div>
                                       )}
                                    </div>
                                    <div className="form-group">
                                       <label htmlFor="password">Password*</label>
                                       <div
                                          className="input-container"
                                          style={{ position: "relative" }}
                                       >
                                          <Field
                                             type={type}
                                             name="password"
                                             className="form-control"
                                          />
                                          <span
                                             className="eyeButton"
                                             onClick={handleTogglePassword}
                                          >
                                             <Icon
                                                className="icon"
                                                icon={icon}
                                                size={20}
                                                style={{
                                                   position: "absolute",
                                                   top: "50%",
                                                   right: "10px",
                                                   transform: "translateY(-50%)",
                                                   cursor: "pointer"
                                                }}
                                             />
                                          </span>
                                       </div>
                                       {errors.password && touched.password && (
                                          <div className="text-danger">{errors.password}</div>
                                       )}
                                    </div>

                                    <div className="form-group">
                                       <label htmlFor="confirmPassword">Confirm Password*</label>
                                       <div
                                          className="input-container"
                                          style={{ position: "relative" }}
                                       >
                                          <Field
                                             type={confirmType}
                                             name="confirmPassword"
                                             className="form-control"
                                          />
                                          <span
                                             className="eyeButton"
                                             onClick={handleToggleConfirmPassword}
                                          >
                                             <Icon
                                                className="icon"
                                                icon={confirmIcon}
                                                size={20}
                                                style={{
                                                   position: "absolute",
                                                   top: "50%",
                                                   right: "10px",
                                                   transform: "translateY(-50%)",
                                                   cursor: "pointer"
                                                }}
                                             />
                                          </span>
                                       </div>

                                       {errors.confirmPassword && touched.confirmPassword && (
                                          <div className="text-danger">
                                             {errors.confirmPassword}
                                          </div>
                                       )}
                                    </div>
                                 </div>
                              </div>

                              {/* Organization Details */}
                              <div className="p-8 bg-white mt-20 form-styleNGO">
                                 <div className="row g-3">
                                    <div className="form-group col-12 col-md-8">
                                       <label>International Organization’s name*</label>
                                       <Field
                                          type="text"
                                          name="internationalName"
                                          className="form-control"
                                       />
                                       {errors.internationalName && touched.internationalName && (
                                          <div className="text-danger">
                                             {errors.internationalName}
                                          </div>
                                       )}
                                    </div>
                                    <div className="form-group col-12 col-md-4">
                                       <label>Foundation year*</label>
                                       <DatePicker
                                          selected={values.dateOfEstablishment}
                                          onChange={(date) =>
                                             setFieldValue("dateOfEstablishment", date)
                                          }
                                          dateFormat="MM/dd/yyyy"
                                          className="form-control"
                                       />
                                       {errors.dateOfEstablishment &&
                                          touched.dateOfEstablishment && (
                                             <div className="text-danger">
                                                {errors.dateOfEstablishment}
                                             </div>
                                          )}
                                    </div>

                                    {/* Other form fields */}
                                    <div className="form-group col-12 col-md-12">
                                       <label>Organization description*</label>
                                       <Field
                                          as="textarea"
                                          name="description"
                                          className="form-control"
                                       />
                                       {errors.description && touched.description && (
                                          <div className="text-danger">{errors.description}</div>
                                       )}
                                    </div>
                                    <div className="form-group col-12 col-md-12">
                                       <label>Sectors*</label>
                                       <Field
                                          name="sectors"
                                          as={Select}
                                          isMulti
                                          options={sectorList} // Replace with your fetched options
                                          value={values.sectors}
                                          onChange={(selectedOptions) =>
                                             setFieldValue("sectors", selectedOptions)
                                          }
                                          placeholder="Select Sectors"
                                       />
                                       {errors.sectors && touched.sectors && (
                                          <div className="text-danger">{errors.sectors}</div>
                                       )}
                                    </div>
                                    {/* Base country */}
                                    <div className="form-group col-md-6">
                                       <label>Base country*</label>
                                       <Field
                                          as={Select}
                                          name="baseCountryId"
                                          value={values.baseCountryId}
                                          placeholder="Base country"
                                          options={countryList} // Replace with your fetched options
                                          onChange={(selectedOption) => {
                                             setFieldValue("baseCountryId", selectedOption);
                                          }}
                                       />
                                       {errors.baseCountryId && touched.baseCountryId && (
                                          <div className="text-danger">
                                             {errors.baseCountryId.value}
                                          </div>
                                       )}
                                    </div>

                                    {/* Organization size */}
                                    <div className="form-group col-md-6">
                                       <label>Organization size*</label>
                                       <Field
                                          as={Select}
                                          name="orgSizeId"
                                          placeholder="Organization size"
                                          options={orgSizeList} // Replace with your fetched options
                                          onChange={(selectedOrgSize) => {
                                             setFieldValue("orgSizeId", selectedOrgSize);
                                          }}
                                       />
                                       {errors.orgSizeId && touched.orgSizeId && (
                                          <div className="text-danger">{errors.orgSizeId}</div>
                                       )}
                                    </div>

                                    {/* Organization address */}
                                    <div className="form-group col-12 col-md-12">
                                       <label>Organization address*</label>
                                       <Field
                                          as="textarea"
                                          name="address"
                                          className="form-control"
                                       />
                                       {errors.address && touched.address && (
                                          <div className="text-danger">{errors.address}</div>
                                       )}
                                    </div>

                                    {/* Organization email */}
                                    <div className="form-group col-12 col-md-12">
                                       <label>Organization's email*</label>
                                       <Field
                                          type="email"
                                          name="organizationEmail"
                                          className="form-control"
                                       />
                                       {errors.organizationEmail && touched.organizationEmail && (
                                          <div className="text-danger">
                                             {errors.organizationEmail}
                                          </div>
                                       )}
                                    </div>
                                 </div>
                              </div>

                              {/* Terms and Submit */}
                              <div className="container">
                                 {/* Checkbox for accepting terms */}
                                 <div className="d-flex w-full ml-2">
                                    <div className="mt-25 my-10">
                                       <label className="checkbox">
                                          <Field
                                             type="checkbox"
                                             name="acceptTerms"
                                             required
                                             className="m-1"
                                          />
                                          <span className="mr-3 checkbox__style" />I have read and
                                          agreed with the {"  "}
                                          <Link
                                             to="/terms"
                                             target="_blank"
                                             className="mr-1 terms-conditions-btn"
                                             rel="noopener noreferrer"
                                          >
                                             <p className="terms-conditions-text ml-2">
                                                {"  "}
                                                terms and conditions.{" "}
                                             </p>
                                          </Link>
                                       </label>
                                       {errors.acceptTerms && touched.acceptTerms && (
                                          <div className="text-danger">{errors.acceptTerms}</div>
                                       )}
                                    </div>
                                 </div>
                                 {/* <div className="container"> */}
                                 <div className="d-flex w-full ml-2 mb-10">
                                    <div className="">
                                       <button type="submit" className="btn ngoBtn">
                                          <p className="ngoBtn-submit">Submit</p>
                                       </button>
                                    </div>
                                 </div>
                                 {/* </div> */}
                              </div>
                           </Form>
                        )}
                     </Formik>
                  </div>
               </div>
            </div>
         </div>
      </div>
   );
}
export default RegistrationOfNationalOrganization;
